import { createSlice } from "@reduxjs/toolkit";
import { createProperty, editProperty, fetchUserProperties, editUnit } from "../thunks/propertyThunks";


const propertySlice = createSlice({
  name: "property",
  initialState: {
    properties: [],
    flag: false
  },
  reducers: {
    setFlag: (state, action) => {
      state.flag = action.payload; // true or false
    },
  },
  extraReducers: (builder) => {

    // fetch user properties
    builder.addCase(fetchUserProperties.fulfilled, (state, action) => {
      state.properties = action.payload.data?.data;
    });

    // create property
    builder.addCase(createProperty.fulfilled, (state, action) => {
      state.properties.push(action.payload?.data);
    });

    // edit property
    builder.addCase(editProperty.fulfilled, (state, action) => {
      // console.log('state.properties', state.properties);
    });

    // edit unit 
    builder.addCase(editUnit.fulfilled, (state, action) => {
      // console.log('edited unit', action.payload.data?.data);
    });
  }
});

export const { setFlag } = propertySlice.actions;
export default propertySlice.reducer;